import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

const sizes = {
  s: { width: 50, height: 50, icon: { topBottom: 11, left: 19 } },
  l: { width: 100, height: 100, icon: { topBottom: 20, left: 34 } }
};

export const PlayButton = ({ size, hover }) => {
  const styles = {
    main: css`
      position: absolute;
      bottom: 0;
      left: 0;
      width: ${sizes[size].width}px;
      height: ${sizes[size].height}px;
      background: ${hover ? '#fc0' : 'rgba(0, 0, 0, 0.8)'};
      z-index: 2;
      &::after {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-bottom: ${sizes[size].icon.topBottom}px solid transparent;
        border-top: ${sizes[size].icon.topBottom}px solid transparent;
        border-left: ${sizes[size].icon.left}px solid ${hover ? '#000' : '#fc0'};
        font-size: 0;
      }
    `
  };

  return <span css={styles.main} />;
};

PlayButton.defaultProps = {
  size: 's',
  hover: false
};

PlayButton.propTypes = {
  size: PropTypes.oneOf(['s', 'l']),
  // Use hover a as a prop, instead of using native CSS :hover, because this component
  // is always used in conjunction with another one that mandates if the play button
  // is hovered or not.
  hover: PropTypes.bool
};
